export interface DefinedListIcd10Code {
  /** Legacy hard-remove flag — the code is gone from the list. */
  isRemoved?: boolean
  /** Legacy active flag used by some DDE rows. */
  active?: boolean
  /** Pharmacist decision from the categorized UI (TOOL-380). */
  acceptanceState?: 'included' | 'excluded'
}

/**
 * Single source of truth for "is this ICD-10 code part of the indication's
 * defined list" — i.e. what renders as Included and what gets exported.
 *
 * Both the PDF and DDE exports filter through this so the categorized UI's
 * notion of the list and the exported artifact can't drift (TOOL-537). A code
 * is in the defined list unless it has been removed (`isRemoved` — gone),
 * marked inactive (`active === false`), or explicitly excluded by the
 * pharmacist (`acceptanceState === 'excluded'`).
 */
export const isIcd10InDefinedList = (code: DefinedListIcd10Code): boolean => {
  if (code.isRemoved === true) return false
  if (code.active === false) return false
  if (code.acceptanceState === 'excluded') return false
  return true
}
